import { isDesktop } from "./utils";
import { loadRecommendations } from "./einsteinUtils";
const contentTileCarousel = require("./contentTilesCarousel.js");
let totalScrollWidth = 0;
let resizeTimer;

/**
* Remove active class for previous selected tab
* @returns {void}
*/
function initTabs() {
    $("a[data-toggle=\"tab\"]").on("shown.bs.tab", function (e) {
        var $currentTarget = $(e.currentTarget);
        $(e.relatedTarget).removeClass("active");
        var $slickTrack = $currentTarget.closest(".slick-track");
        var link = $currentTarget.attr("href");

        $slickTrack.find(`.tab-link:not([href='${link}']`).removeClass("active");
        $slickTrack.find(`.tab-link[href='${link}']`).addClass("active");

        var tabID = $(e.target).attr("href");
        var $tabEl = $(tabID);

        if ($tabEl.length > 0) {
            var $selectedCarousel = $tabEl.find(".js-content-tiles-carousel");
            var $layoutContainer = $selectedCarousel.parent();
            var einsteinRecommender = $layoutContainer.attr("data-einstein-recommender");

            if ($selectedCarousel.length && !$selectedCarousel.hasClass("slick-initialized")) {
                if (einsteinRecommender) {
                    loadRecommendations($layoutContainer, einsteinRecommender, contentTileCarousel.initContentTileCarousel);
                } else {
                    contentTileCarousel.initContentTileCarousel($selectedCarousel);
                }
            }
        }
    });
}

/**
* Removes the Slick carousel from the given tab slider element and re-initializes the tabs
* @param {element} $tabSlider - The jQuery object representing the tab slider element
* @returns {void}
*/
function resetTabSliderWithTabs($tabSlider) {
    $tabSlider.slick("unslick");
    initTabs();

    var isScrollVisible = $tabSlider[0].scrollWidth > $tabSlider[0].clientWidth;

    if (isScrollVisible) {
        setTotalTabsWidth();
        initCarousel();
    }
}

/**
* Initializes the tab carousel for displaying content tabs
* @returns {void}
*/
function initCarousel() {
    var $tabSlider = $(".js-content-tab-carousel");
    var isInitialized = $tabSlider.hasClass("slick-initialized");
    var isDesktopValue = isDesktop();

    if ($tabSlider.length > 0) {
        if (isDesktopValue && isInitialized) {
            resetTabSliderWithTabs($tabSlider);
        } else if (!isDesktopValue) {
            var isContentOverflowing = Math.ceil($tabSlider.innerWidth()) < totalScrollWidth;

            if (isInitialized) {
                if (!isContentOverflowing) {
                    resetTabSliderWithTabs($tabSlider);
                }
            } else if (isContentOverflowing) {
                $tabSlider.slick({
                    lazyLoad: "ondemand",
                    slidesToShow: 1,
                    pauseOnFocus: false,
                    mobileFirst: true,
                    variableWidth: true,
                    infinite: true,
                    arrows: false
                });
            }
        }
    }
}

/**
* Sets the total width of the tabs in the carousel
*/
function setTotalTabsWidth() {
    var $tabSlider = $(".js-content-tab-carousel");

    if ($tabSlider.length) {
        totalScrollWidth = $tabSlider[0].scrollWidth;
    }
}

export default function () {
    initTabs();
    setTotalTabsWidth();
    initCarousel();

    $(window).resize(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            setTotalTabsWidth();
            initCarousel();
        }, 200);
    });
}
